'use client';

import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import NProgress from 'nprogress';
import { store } from '@/src/v2/store';
import { getQueryClient } from '@/src/v2/service/graphql/api';
import { Amplify } from '@aws-amplify/core';
// import { awsConfig } from '@/src/utils/amplify';
import { klicTheme } from '@/styles/theme/theme';
import { NextUIProvider } from '@nextui-org/react';
import awsConfig from '@/src/utils/awsExports';

Amplify.configure({ ...awsConfig, ssr: true });

const Providers: FC<PropsWithChildren> = ({ children }) => {
  const [queryClient] = useState(() => getQueryClient()); // Are we providing the global QueryClient from the correct API endpoint?

  useEffect(() => {
    NProgress.start();
  }, []);

  return (
    <Provider store={store}>
      <NextUIProvider theme={klicTheme}>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </NextUIProvider>
    </Provider>
  );
};

export default Providers;
